import { useState } from "react";
import { Alert } from "react-bootstrap";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { API } from "../../config/api";

function AddCategory() {
  document.title = "Add Category";

  let navigate = useNavigate();
  const [message, setMessage] = useState("");

  const [category, setCategory] = useState("");

  const handleChange = (e) => {
    setCategory(e.target.value);
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();

      // Configuration
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      // Data body
      const body = JSON.stringify({ name: category });

      // Insert category data
      const response = await API.post("/category", body, config);

      navigate("/category");
    } catch (error) {
      const alert = (
        <Alert variant="danger" className="py-1">
          {error.response.data.message || error.response.data.error.message}
        </Alert>
      );
      setMessage(alert);
      console.log(error);
    }
  });

  return (
    <>
      <NavigasiAdmin active="category" />
      <div className="edit-category-section container">
        <p className="mt-5 fw-bold">Add Category</p>
        <form onSubmit={(e) => handleSubmit.mutate(e)}>
          {message && message}

          <input
            onChange={handleChange}
            type="text"
            name="add"
            id="add"
            className="form-control bg-dark mb-4 text-white"
          />
          <button className="btn btn-success fw-bold w-100">Save</button>
        </form>
      </div>
    </>
  );
}

export default AddCategory;
